import React, { useContext } from "react";
import { useIntl } from "react-intl";
// mui
import Grid from "@mui/material/Grid";
import Typography from "@mui/material/Typography";
import TextField from "@mui/material/TextField";
import Alert from "@mui/material/Alert";
import { StoreContext } from "../../../../../../../../../../../store/StoreProvider";
import Act from "../../../../../../../../../../../store/actions";
// img
import iconWarnInfo from "../../../../../../../../../../../../images/ai_image/info.svg";

const MainLeft = () => {
  const [state, dispatch] = useContext(StoreContext);
  const { sna } = state;
  const { InputTxt } = sna.AI;
  const intl = useIntl();
  return (
    <Grid
      className="AI_main_left"
      item
      xs
      sx={{
        marginRight: "8px",
        backgroundColor: "#FFFFFF",
        padding: "16px 24px 24px 16px",
        borderRadius: "8px",
        boxShadow: "0 8px 16px 0 #096C9B1A",
        height: "calc(100vh - 170px)",
      }}
    >
      <Typography
        sx={{
          paddingBottom: "8px",
          fontWeight: "700",
          marginBottom: "16px",
        }}
      >
        {" "}
        {intl.formatMessage({
          id: "sna.sidetool.digitalAITool.ai.preview.title",
          defaultMessage: "1-1. 文字預覽",
        })}
      </Typography>{" "}
      <Grid>
        <TextField
          className="AI_input"
          value={InputTxt}
          fullWidth
          multiline
          rows={28}
          onChange={(e) =>
            dispatch({
              type: Act.SNA_SET_AI_INPUT_TXT,
              payload: e.target.value,
            })
          }
          placeholder="請點擊「匯入本機檔案」匯入TXT檔案或於此處貼上文字"
          sx={{ height: { xs: "50vh", xl: "60vh" }, marginBottom: "16px" }}
        />
        {InputTxt.length > 4000 && (
          <Alert
            icon={<img src={iconWarnInfo} alt="WarnInfo" />}
            sx={{
              fontSize: "0.875rem",
              backgroundColor: "#FFF1F1",
              fontWeight: "400",
              padding: "12px 16px 12px 16px",
              borderRadius: "4px",
              color: "#F83B3B",
            }}
          >
            {`文字字數已超過 ${InputTxt.length}/4000字，請縮減字數。`}
          </Alert>
        )}
        <Typography sx={{ fontSize: "0.875rem", marginTop: "16px" }}>
          {" "}
          {intl.formatMessage({
            id: "sna.sidetool.digitalAITool.ai.hintword.title",
            defaultMessage:
              "分析模型最多可運算4000字，建議將文字分段以提升AI正確率！",
          })}
        </Typography>
      </Grid>
    </Grid>
  );
};

export default MainLeft;
